export default __webpack_public_path__ + "static/media/poster23.8372abd2.png";